<template>
  <v-row justify="center">
    <v-dialog v-model="dialogLogin" persistent max-width="600px" @click:outside="toggleDialogLogin">
      <v-card>
        <v-card-title>
          <span class="headline">Identificação</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" v-if="!this.proximaEtapa">
                <v-text-field autofocus
                  label="Informe seu CPF"
                  type="number"
                  v-model.lazy="cpf"
                  counter="11"
                  hint="O Sistema irá procurar o seu CPF"
                  :loading="procurandoCPF"
                  :error-messages="erroCPF"
                  v-on:keyup.enter="avancar()"
                ></v-text-field>
              </v-col>
              <v-row v-if="proximaEtapa && novo">
                <v-col cols="12">
                  <h2>Um pouco mais sobre você...</h2>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field label="Informe se Nome Completo" name="name" v-model="nome" autofocus></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Informe seu Celular/Whatsapp"
                    v-model="celular"
                    name="celular"
                    v-mask="'(##) #####-####'"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field label="Informe seu Email" name="email" v-model="email" v-on:keyup.enter="avancar()"></v-text-field>
                </v-col>
                <!--<v-col cols="12" md="6">
                  <v-text-field
                    label="Informe sua Senha"
                    v-model="senha"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassword ? 'text' : 'password'"
                    hint="Senha não pode ficar em branco"
                    @click:append="showPassword = !showPassword"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field label="Confirme a senha desejada" v-model="confirmaSenha"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassword ? 'text' : 'password'"
                    hint="Senha não pode ficar em branco"
                    @click:append="showPassword = !showPassword"
                    :error-messages="erroSenha"
                    v-on:keyup.enter="avancar()"
                  ></v-text-field>
                </v-col>-->
              </v-row>
              <v-col cols="12" v-if="proximaEtapa && !novo">
                <v-text-field
                    label="Informe seu Celular/Whatsapp"
                    v-model="senha"
                    name="senha"
                    v-mask="'(##) #####-####'"
                  :error-messages="erroAjax"
                  v-on:keyup.enter="avancar()"></v-text-field>
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="toggleDialogLogin()">Cancelar</v-btn>
          <v-btn color="blue darken-1" v-if="proximaEtapa" text @click="proximaEtapa = false">Voltar</v-btn>
          <v-btn color="blue darken-1" text @click="avancar()">Avançar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  name: 'PreCadastro',
  data: () => ({
    cpf: '',
    procurandoCPF: false,
    erroCPF: '',
    erroSenha: '',
    novo: true,
    showPassword: false,
    nome: '',
    senha: '',
    confirmaSenha: '',
    proximaEtapa: false,
    cadastrado: false,
    celular: '',
    email: ''
  }),
  computed: {

    ...mapState(['dialogLogin', 'goToAfterLogin', 'erroAjax'])
  },
  methods: {
    ...mapMutations(['toggleDialogLogin']),
    ...mapActions(['getCPF', 'cadastrarVisitante', 'loginVisitante']),
    avancar: function () {
      if (!this.proximaEtapa) {
        this.primeiraEtapa()
      } else {
        if (this.novo) {
          if (this.senha !== this.confirmaSenha) {
            this.erroSenha = 'As senhas informadas não conferem'
          } else {
            this.cadastrarVisitante({
              cpf: this.cpf,
              nome: this.nome,
              senha: this.senha,
              celular: this.celular,
              email: this.email
            }).then(() => {
              this.toggleDialogLogin()
              this.$router.push(this.goToAfterLogin)
            })
          }
        } else {
          this.loginVisitante({ cpf: this.cpf, senha: this.senha, to: this.goToAfterLogin }).then(x => console.log('catch', x))
            .catch(x => console.log('catch', x))
        }
      }
    },
    primeiraEtapa: function () {
      this.erroCPF = ''
      if (this.cpf.length !== 11) {
        this.erroCPF = 'O CPF deve conter 11 caracteres'
      } else if (!this.validaCPF()) {
        this.erroCPF = 'O CPF parece estar inválido, verifique o numero e tente novamente'
      } else {
        this.procurandoCPF = true
        this.getCPF(this.cpf).then(result => {
          if (result) {
            this.procurandoCPF = false
            if (result.status === 200) {
              this.proximaEtapa = true
              if (result.data.data) {
                if (result.data.data.id) {
                  this.toggleDialogLogin()
                  this.$router.push('/pagamento/selecione')
                }
                this.novo = false
              } else {
                this.novo = true
              }
            } else {
              this.erroCPF = 'O CPF parece estar inválido, verifique o numero e tente novamente'
            }
          }
        })
      }
    },
    validaCPF: function () {
      const cpf = this.cpf.toString().replace(/[^0-9]/g, '')
      if (!cpf || cpf.length !== 11 || cpf === '00000000000' || cpf === '11111111111' || cpf === '22222222222' ||
        cpf === '33333333333' || cpf === '44444444444' || cpf === '55555555555' || cpf === '66666666666' ||
        cpf === '77777777777' || cpf === '88888888888' || cpf === '99999999999') {
        return false
      }
      let soma = 0
      let resto
      for (let i = 1; i <= 9; i++) {
        soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i)
      }
      resto = (soma * 10) % 11
      if (resto === 10 || resto === 11) resto = 0
      if (resto !== parseInt(cpf.substring(9, 10))) return false
      soma = 0
      for (let i = 1; i <= 10; i++) {
        soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i)
      }
      resto = (soma * 10) % 11
      if (resto === 10 || resto === 11) resto = 0
      if (resto !== parseInt(cpf.substring(10, 11))) return false
      return true
    }
  }
}
</script>
